import axios from 'axios';
import handleError from '../../../../../../../components/FormHelpers/handleError';

const submitForm = async (values, next, setError) => {
  const { codeInputs } = values;


  const authCode = codeInputs.map((value) => `${value}`).join('');

  try {
    await axios.post('/api/authenticate/', {
      authCode: authCode
    });
    next();
  } catch (err) {
    handleError(err.response, setError);
    throw err;
  }
};

export default submitForm;
